/**
 * @fileoverview Main App component with routing for ISCRI Dashboard
 * @author SKEMA CANADA
 */

import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import AppRouter from "@router";

import { AuthProvider } from "@contexts/AuthContext";
import { CountryProvider } from "@contexts/CountryContext";
import { ChartProvider } from "@contexts/ChartContext";
import { UIProvider } from "@contexts/UIContext";

import "@styles/variables.css";
import "@styles/globals.css";

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div className="error-boundary">
      <div className="error-container">
        <h2>Something went wrong</h2>
        <p>An unexpected error occurred while loading the ISCRI application.</p>
        <details style={{ whiteSpace: "pre-wrap", marginTop: "1rem" }}>
          {error.message}
        </details>
        <button onClick={resetErrorBoundary} className="button">
          Try again
        </button>
      </div>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => window.location.reload()}
    >
      <BrowserRouter>
        <AuthProvider>
          <UIProvider>
            <CountryProvider>
              <ChartProvider>
                <div className="app">
                  <AppRouter />
                </div>
              </ChartProvider>
            </CountryProvider>
          </UIProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
